import { Box, Container, Typography } from "@mui/material";
import { Link, useRouteError } from "react-router-dom";

import { colors } from "@/deal-room/theme/tokens";

interface ErrorResponse {
    status: number;
    statusText?: string;
    data?: unknown;
}

function isErrorResponse(err: unknown): err is ErrorResponse {
    return (
        typeof err === "object" &&
        err !== null &&
        "status" in err &&
        typeof (err as { status: unknown }).status === "number"
    );
}

export function NotFound() {
    const err = useRouteError();
    const status = isErrorResponse(err) ? err.status : 404;
    const message =
        isErrorResponse(err) && typeof err.data === "string"
            ? err.data
            : status === 404
              ? "Deal room not found."
              : "Something went wrong loading this page.";

    return (
        <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
            <Box
                sx={{
                    p: 5,
                    bgcolor: "background.paper",
                    border: 1,
                    borderColor: "divider",
                    borderRadius: "10px",
                    textAlign: "center",
                }}
            >
                <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 1 }}>
                    {status === 404 ? "Not found" : "Error"}
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 3 }}>
                    {message}
                </Typography>
                <Link
                    to="/"
                    style={{
                        color: colors.navy,
                        fontWeight: 600,
                        textDecoration: "underline",
                        textDecorationColor: colors.brandOrange,
                        textDecorationThickness: 2,
                        textUnderlineOffset: 2,
                    }}
                >
                    Back to home
                </Link>
            </Box>
        </Container>
    );
}
